<template>
    <div v-loading="isBusy">
        <h2>Payments</h2>
        <div class="row">
            <div class="col-sm-12">
                <a :href="url(`admin/employer/${employerId}/braintree`)" class="btn btn-primary">
                    <i class="fa fa-credit-card" aria-hidden="true"></i> Braintree Integration
                </a>
                <a :href="url(`admin/employer/${employerId}/paygate`)" class="btn btn-primary">
                    <i class="fa fa-credit-card" aria-hidden="true"></i> Stripe Integration
                </a>
            </div>
        </div>
        <div class="table-responsive" style="margin-top:20px;">
            <table class="table table-striped table-hover">

                <thead>
                <tr>
                    <th></th>
                    <th>Billable</th>
                    <th>Spend</th>
                    <th>Agency</th>
                    <th>Net Invoice</th>
                    <th>Status</th>
                </tr>
                </thead>

                <EmployerPaymentsDrilldown  v-for="(row, index) in rows"
                                            :show-older="showOlder"
                                            :key="`payments-drilldown-${index}`"
                                            :index="index"
                                            @open-net-invoice-dialog="openNetInvoiceDialog"
                                            @open-payment-status-dialog="openPaymentStatusDialog"
                                            @open-agency-dialog="openAgencyDialog"
                                            :row="row"></EmployerPaymentsDrilldown>
            </table>
        </div>
        <el-button type="text" @click="showOlder = true" v-if="!showOlder && rows.length > 6">Show More</el-button>
        <el-button type="text" @click="showOlder = false" v-else-if="rows.length > 6">Show Less</el-button>

        <el-dialog
            title="Net Invoice"
            :visible.sync="netInvoiceDialog.isVisible"
            width="30%"
            :close-on-click-modal="false"
            :before-close="closeNetInvoiceDialog">
            <div>
                <el-input type="text" v-model="netInvoiceDialog.value"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeNetInvoiceDialog">Cancel</el-button>
                <el-button type="primary" @click="saveNetInvoice"><i class="fa fa-pulse fa-spinner" v-if="netInvoiceDialog.isBusy"></i> Save</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="Payment Status"
            :visible.sync="statusDialog.isVisible"
            width="30%"
            :close-on-click-modal="false"
            :before-close="closePaymentStatusDialog">
            <div>
                <el-select v-model="statusDialog.value" style="width:100%">
                    <el-option v-for="op in statusOptions" :label="op" :value="op" :key="`status-${op}`"></el-option>
                </el-select>
                <el-date-picker v-model="statusDialog.date"
                                v-if="statusDialog.value === 'Invoiced' || statusDialog.value === 'Paid'"
                                style="width:100%;margin-top:5px;"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="Pick a day"></el-date-picker>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closePaymentStatusDialog">Cancel</el-button>
                <el-button type="primary" @click="savePaymentStatus"><i class="fa fa-pulse fa-spinner" v-if="statusDialog.isBusy"></i> Save</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="Agency"
            :visible.sync="agencyDialog.isVisible"
            width="30%"
            :close-on-click-modal="false"
            :before-close="closeAgencyDialog">
            <div>
                <el-select v-model="agencyDialog.value" style="width:100%">
                    <el-option v-for="ag in agencies" :label="ag.text" :value="ag.value" :key="`agency-${ag.value}`"></el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeAgencyDialog">Cancel</el-button>
                <el-button type="primary" @click="saveAgency"><i class="fa fa-pulse fa-spinner" v-if="agencyDialog.isBusy"></i> Save</el-button>
            </span>
        </el-dialog>

        <employer-notes-wrapper :employer-id="employerId" />
    </div>
</template>

<script>
import EmployerPaymentsDrilldown from './employer-payments-drilldown';

export default {
    components: { EmployerPaymentsDrilldown },
    props: {
        agencies: { type: Array, required: true },
        employerId: { type: Number, required: true },
    },
    data() {
        return {
            isBusy: false,
            showOlder: false,
            rows: [],
            netInvoiceDialog: {
                value: '',
                period: null,
                employer: null,
                index: null,
                isVisible: false,
                isBusy: false,
            },
            statusOptions: ['Assumed', 'Invoiced', 'Paid', 'Not Advertising'],
            statusDialog: {
                value: 'Assumed',
                date: '',
                period: null,
                employer: null,
                index: null,
                isVisible: false,
                isBusy: false,
            },
            agencyDialog: {
                value: '',
                period: null,
                employer: null,
                index: null,
                isVisible: false,
                isBusy: false,
            },
        };
    },
    mounted() {
        this.reloadData();
    },
    methods: {
        openAgencyDialog(data) {
            data['isVisible'] = true;
            data['isBusy'] = false;
            this.agencyDialog = data;
        },
        closeAgencyDialog() {
            this.agencyDialog.isVisible = false;
            this.agencyDialog.isBusy = false;
            this.agencyDialog.value = '';
            this.agencyDialog.period = null;
            this.agencyDialog.employer = null;
            this.agencyDialog.index = null;
        },
        saveAgency() {
            this.agencyDialog.isBusy = true;
            return axios.post(url(`ajax/admin/employer/${this.agencyDialog.employer}/payments/agency`), {
                pk: this.agencyDialog.period,
                value: this.agencyDialog.value,
            }).then(response => {
                this.rows[this.agencyDialog.index].agency_id = this.agencyDialog.value;
                this.rows[this.agencyDialog.index].agency_name = response.data;
            }).finally(() => {
                this.closeAgencyDialog();
            });
        },
        openNetInvoiceDialog(data) {
            data['isVisible'] = true;
            data['isBusy'] = false;
            this.netInvoiceDialog = data;
        },
        closeNetInvoiceDialog() {
            this.netInvoiceDialog.isVisible = false;
            this.netInvoiceDialog.isBusy = false;
            this.netInvoiceDialog.value = '';
            this.netInvoiceDialog.period = null;
            this.netInvoiceDialog.employer = null;
            this.netInvoiceDialog.index = null;
        },
        saveNetInvoice() {
            this.netInvoiceDialog.isBusy = true;
            return axios.post(url(`ajax/admin/employer/${this.netInvoiceDialog.employer}/payments/net-invoice`), {
                pk: this.netInvoiceDialog.period,
                value: this.netInvoiceDialog.value,
            }).then(response => {
                this.rows[this.netInvoiceDialog.index].net_invoice = this.netInvoiceDialog.value;
            }).finally(() => {
                this.closeNetInvoiceDialog();
            });
        },
        openPaymentStatusDialog(data) {
            data['date'] = '';
            data['isVisible'] = true;
            data['isBusy'] = false;
            this.statusDialog = data;
        },
        closePaymentStatusDialog() {
            this.statusDialog.isVisible = false;
            this.statusDialog.isBusy = false;
            this.statusDialog.value = 'Assumed';
            this.statusDialog.date = '';
            this.statusDialog.period = null;
            this.statusDialog.employer = null;
            this.statusDialog.index = null;
        },
        savePaymentStatus() {
            this.statusDialog.isBusy = true;

            const params = {
                pk: this.statusDialog.period,
                value: { state: this.statusDialog.value },
            };

            if (params.value.state === 'Paid') params['value']['paid_date'] = this.statusDialog.date;
            else if (params.value.state === 'Invoiced') params['value']['invoiced_date'] = this.statusDialog.date;

            return axios.post(url(`ajax/admin/employer/${this.statusDialog.employer}/payments/paid-status`), params)
                        .then(response => {
                            let status = this.statusDialog.value;
                            if (status === 'Invoiced' || status === 'Paid') {
                                status += ', ' + moment(this.statusDialog.date).format('ddd MMMM D YYYY');
                            }
                            this.rows[this.statusDialog.index].paid_status_text = status;
                        })
                        .finally(() => {
                            this.closePaymentStatusDialog();
                        });
        },
        reloadData() {
            this.isBusy = true;

            return axios.get(url(`admin/employer/${this.employerId}/get-payments-data`))
                        .then(response => {
                            this.rows = response.data.rows;
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
        },
    },
};
</script>

<style scoped>

</style>
